import React from "react";
import { Typography, Box, Button, Grid, Card, List, ListItem, ListItemText } from "@mui/material";
import TriangleBackground from "../layout/TriangleBackground";
import LogoIcon from "../../assets/logo.png"; // your logo
import Slider from "react-slick"; // make sure to install react-slick and slick-carousel
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import DesignServicesIcon from '@mui/icons-material/DesignServices';
import LightbulbIcon from '@mui/icons-material/Lightbulb';
import AutoFixHighIcon from '@mui/icons-material/AutoFixHigh';




// Example icons
import WebIcon from "@mui/icons-material/Web";
import PhoneIphoneIcon from "@mui/icons-material/PhoneIphone";
import CloudIcon from "@mui/icons-material/Cloud";
import StorageIcon from "@mui/icons-material/Storage";
import SmartToyIcon from "@mui/icons-material/SmartToy";
import careerimge from "../../assets/images/careerimg.jpeg";
const About = ({ mode }) => {
    const DColors = ["#FF69B4", "#35ca35", "#FFA500", "#00BFFF"]; // pink, green, orange, blue




    const textSegments = [
        { letter: "H", color: DColors[0] },
        { text: "ELLO " },
        { letter: "W", color: DColors[1] },
        { text: "ORLD. " },
        { text: "THIS IS US." },

    ];

    // Example services array
    const services = [
        {
            title: "Web Development",
            icon: <WebIcon fontSize="large" color="primary" />,
            points: ["Responsive websites", "Modern UI/UX", "SEO-friendly"],
        },
        {
            title: "Mobile Development",
            icon: <PhoneIphoneIcon fontSize="large" color="primary" />,
            points: ["iOS & Android apps", "Cross-platform", "Performance optimized"],
        },
        {
            title: "Cloud Computing",
            icon: <CloudIcon fontSize="large" color="primary" />,
            points: ["AWS, Azure, GCP", "Scalable infrastructure", "Serverless options"],
        },
        {
            title: "Middleware",
            icon: <StorageIcon fontSize="large" color="primary" />,
            points: ["Integration services", "APIs & messaging", "Data pipelines"],
        },
        {
            title: "GenAI",
            icon: <SmartToyIcon fontSize="large" color="primary" />,
            points: ["AI-powered solutions", "Automation", "Chatbots & NLP"],
        },
    ];

    // Slider settings
    const sliderSettings = {
        dots: false,
        arrows: false,
        infinite: true,
        speed: 500,
        slidesToShow: 4,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2000,
        pauseOnHover: false,
        responsive: [
            { breakpoint: 1200, settings: { slidesToShow: 3 } },
            { breakpoint: 900, settings: { slidesToShow: 2 } },
            { breakpoint: 600, settings: { slidesToShow: 1 } },
            { breakpoint: 480, settings: { slidesToShow: 1 } }, // Add more granular breakpoint for smaller devices
        ],
    };


    return (
        <div>
            {/* === Hero Section with Triangle Background === */}
            <TriangleBackground mode={mode}>
                <Box
                    sx={{
                        display: "flex",
                        flexDirection: { xs: "column", md: "column" },
                        alignItems: "center",
                        justifyContent: "center",
                        px: 2,
                        gap: 4,
                        height: "100%",
                        width: "100%"
                    }}
                >
                    {/* Content on the left */}
                    <Box
                        sx={{
                            width: { xs: "100%", md: "100%" },
                            textAlign: { xs: "center", md: "center" },
                        }}
                    >

                        <Typography
                            variant="h3"
                            sx={{
                                fontWeight: "bold",
                                mb: 2,
                                color: mode === "dark" ? "#fff" : "#000",
                            }}
                        >
                            {textSegments.map((seg, idx) =>
                                seg.letter ? (
                                    <span key={idx} style={{ color: seg.color }}>
                                        {seg.letter}
                                    </span>
                                ) : (
                                    <span key={idx}>{seg.text}</span>
                                )
                            )}
                        </Typography>

                        <Typography
                            variant="h4"

                            sx={{ color: mode === "dark" ? "#ccc" : "#444" }}
                        >
                            We are happy and passionate people committed to solving big problems
                        </Typography>
                    </Box>

                    {/* Logo on the right */}
                    {/* <Box
            component="img"
            src={LogoIcon}
            alt="Olyviatech Logo"
            className="spin-fade-logo"
            sx={{
              width: { xs: 120, sm: 150, md: 250 },
              height: "auto",
            }}
          /> */}
                </Box>
            </TriangleBackground>
            <section style={{ padding: "60px 20px", backgroundColor: mode === "dark" ? "#0f0f0f" : "#fafafa" }}>
                <Box sx={{ maxWidth: "800px", mx: "auto", textAlign: "center" }}>
                    <Box
                        component="img"
                        src={LogoIcon}
                        alt="Olyvia Tech Logo"
                        sx={{
                            width: 80,
                            height: "auto",
                            mb: 2,
                        }}
                    />
                    <Typography variant="h5" sx={{ fontWeight: "bold", color: mode === "dark" ? "#fff" : "#000", mb: 1 }}>
                        About Olyvia Tech
                    </Typography>
                    <Typography variant="body1" sx={{ color: mode === "dark" ? "#ccc" : "#444" }}>
                        Olyvia Tech is a passionate team of engineers, designers, and thinkers who believe in building purposeful digital solutions.
                        Our mission is to help businesses thrive in the digital age through innovation, collaboration, and technology.
                    </Typography>
                </Box>
            </section>

            {/* === Digital Strategy Section === */}
            <section
                style={{
                    padding: "80px 20px",
                    position: "relative",
                    backgroundColor: mode === "dark" ? "#1a1a1a" : "#f9f9f9",
                    overflow: "hidden",
                }}
            >
                {/* Faded background icon/logo */}
                <Box
                    component="img"
                    src={LogoIcon}
                    alt="Olyvia Tech Logo Background"
                    sx={{
                        position: "absolute",
                        left: "-100px",
                        top: "20px",
                        width: { xs: "300px", md: "600px" },
                        opacity: 0.05,
                        zIndex: 0,
                    }}
                />

                <Box sx={{ position: "relative", zIndex: 1, maxWidth: "1000px", mx: "auto", textAlign: "center" }}>
                    <Typography
                        variant="h4"
                        sx={{
                            fontWeight: "bold",
                            color: mode === "dark" ? "#fff" : "#000",
                            mb: 3,
                        }}
                    >
                        Digital strategy consulting that gets results
                    </Typography>
                    <Typography
                        variant="body1"
                        sx={{
                            fontSize: "1.1rem",
                            lineHeight: 1.8,
                            color: mode === "dark" ? "#ccc" : "#444",
                        }}
                    >
                        We are a forward-thinking digital strategy consultancy, passionate about innovation, collaboration, and driving transformative digital experiences. With expertise across global brands, top consultancies, high-growth startups, Fortune 500 companies, and governments, we empower organizations to thrive in the digital age. Our mission is to accelerate digital transformation, unlocking powerful, lasting impact for our clients in today’s rapidly evolving tech landscape.
                    </Typography>
                </Box>
            </section>

            {/* === Technology Value Cards === */}

            <section style={{ padding: "60px 20px", backgroundColor: mode === "dark" ? "#111" : "#fff" }}>
                <Box sx={{ maxWidth: "1200px", mx: "auto" }}>
                    <Typography variant="h5" sx={{ fontWeight: "bold", color: mode === "dark" ? "#fff" : "#000", mb: 8, textAlign: "center" }}>
                        Amazing things happen to your business when we connect these dots of utility and value.
                    </Typography>

                    <Grid container spacing={4} justifyContent="center">
                        {[
                            {
                                title: "Design",
                                subtitle: "Be Creative. Create the Best.",
                                icon: <DesignServicesIcon sx={{ fontSize: 40, color: "#90ee90" }} />, // Light green
                            },
                            {
                                title: "Innovate",
                                subtitle: "Be Innovative. Innovate the Next.",
                                icon: <LightbulbIcon sx={{ fontSize: 40, color: "#90ee90" }} />,
                            },
                            {
                                title: "Transform",
                                subtitle: "Be Functional. Refine the Rest.",
                                icon: <AutoFixHighIcon sx={{ fontSize: 40, color: "#90ee90" }} />,
                            },
                        ].map((card, index) => (
                            <Grid item xs={12} sm={6} md={4} key={index}>
                                <Card
                                    sx={{
                                        p: 4,
                                        height: "100%",
                                        backgroundColor: mode === "dark" ? "#1e1e1e" : "#f5f5f5",
                                        color: mode === "dark" ? "#fff" : "#000",
                                        textAlign: "center",
                                        boxShadow: 3,
                                        borderRadius: 3,
                                    }}
                                >
                                    {/* Icon */}
                                    <Box sx={{ mb: 2 }}>{card.icon}</Box>

                                    {/* Title */}
                                    <Typography
                                        variant="h5"
                                        sx={{ fontWeight: "bold", mb: 1, color: mode === "dark" ? "#FF69B4" : "#1976d2" }}
                                    >
                                        {card.title}
                                    </Typography>

                                    {/* Subtitle */}
                                    <Typography variant="body1" sx={{ color: mode === "dark" ? "#ccc" : "#555" }}>
                                        {card.subtitle}
                                    </Typography>
                                </Card>
                            </Grid>
                        ))}
                    </Grid>
                </Box>
            </section>

            {/* === About Our Logo Section === */}
            {/* === About Our Logo & Identity Section === */}
            <section
                style={{
                    padding: "100px 20px",
                    background: mode === "dark"
                        ? "radial-gradient(circle, #0f0f0f, #1a1a1a)"
                        : "linear-gradient(to bottom, #f0f4f8, #ffffff)",
                    position: "relative",
                    overflow: "hidden",
                }}
            >
                <Box
                    sx={{
                        maxWidth: "1200px",
                        mx: "auto",
                        display: "flex",
                        flexDirection: { xs: "column", md: "row" },
                        alignItems: "center",
                        gap: { xs: 6, md: 10 },
                    }}
                >
                    {/* Logo with background layering */}
                    <Box sx={{ position: "relative", flex: 1, display: "flex", justifyContent: "center" }}>
                        <Box
                            component="img"
                            src={LogoIcon}
                            alt="Olyvia Tech Logo"
                            sx={{
                                width: { xs: "220px", md: "300px" },
                                height: "auto",
                                zIndex: 2,
                                borderRadius: "20px",
                                transition: "transform 0.5s ease-in-out",
                                "&:hover": {
                                    transform: "scale(1.05)",
                                },
                            }}
                        />
                        {/* Decorative blurred background glow */}
                        <Box
                            sx={{
                                position: "absolute",
                                width: "300px",
                                height: "300px",
                                background: "linear-gradient(45deg, #ff69b4, #00BFFF)",
                                opacity: 0.15,
                                filter: "blur(100px)",
                                borderRadius: "50%",
                                zIndex: 1,
                                top: "20%",
                                left: "10%",
                            }}
                        />
                    </Box>

                    {/* Text Content */}
                    <Box sx={{ flex: 2 }}>
                        <Typography
                            variant="h4"
                            sx={{
                                fontWeight: "bold",
                                color: mode === "dark" ? "#fff" : "#000",
                                mb: 3,
                            }}
                        >
                            About Our Logo & Identity
                        </Typography>

                        <Typography
                            variant="body1"
                            sx={{
                                color: mode === "dark" ? "#ccc" : "#444",
                                lineHeight: 1.8,
                                mb: 3,
                                fontSize: "1.1rem",
                            }}
                        >
                            <strong>Olyvia Tech</strong> combines elegance and precision. The name “Olyvia” evokes clarity, innovation, and
                            timeless simplicity — core values we embed in every project. “Tech” is our foundation: bold digital engineering
                            with a purpose.
                        </Typography>

                        <Typography
                            variant="body1"
                            sx={{
                                color: mode === "dark" ? "#ccc" : "#444",
                                lineHeight: 1.8,
                                fontSize: "1.05rem",
                            }}
                        >
                            Our dynamic logo reflects the synergy between creativity, intelligence, and purpose-driven technology.
                            <ul style={{ marginTop: '10px', paddingLeft: '1.5rem' }}>
                                <li><strong style={{ color: "#FF69B4" }}>Pink:</strong> Creativity & human-centered design</li>
                                <li><strong style={{ color: "#35ca35" }}>Green:</strong> Innovation, sustainability & growth</li>
                                <li><strong style={{ color: "#FFA500" }}>Orange:</strong> Momentum, strategy & action</li>
                                <li><strong style={{ color: "#00BFFF" }}>Blue:</strong> Intelligence, trust & technology</li>
                            </ul>
                            The swirl represents unity in diversity — a seamless blend of skills and ideas converging to build impactful
                            digital experiences. The black canvas behind it symbolizes clarity emerging from complexity — just like our work.
                        </Typography>
                    </Box>
                </Box>
            </section>



            {/* === CTA Section: Have a Question? === */}
            <section
                style={{
                    position: "relative",
                    padding: "120px 20px",
                    backgroundColor: "#000", // force dark background for stars
                    overflow: "hidden",
                }}
            >
                {/* Animated stars background */}
                <Box
                    sx={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                        backgroundImage: `
        radial-gradient(white 1px, transparent 1px),
        radial-gradient(white 1px, transparent 1px)
      `,
                        backgroundSize: "40px 40px",
                        backgroundPosition: "0 0, 20px 20px",
                        animation: "moveStars 60s linear infinite",
                        opacity: 0.5,
                        zIndex: 0,
                    }}
                />

                {/* Foreground content */}
                <Box
                    sx={{
                        position: "relative",
                        zIndex: 2,
                        maxWidth: "800px",
                        mx: "auto",
                        textAlign: "center",
                    }}
                >
                    <Typography
                        variant="h4"
                        sx={{
                            fontWeight: "bold",
                            color: "#fff",
                            mb: 4,
                        }}
                    >
                        Have a question? We're happy to help
                    </Typography>

                    <Button
                        variant="contained"
                        href="/contact"
                        sx={{
                            backgroundColor: "#4caf50",
                            color: "#ffff",
                            fontWeight: "bold",
                            px: 5,
                            py: 1.5,
                            fontSize: "1rem",
                            borderRadius: "8px",
                            '&:hover': {
                                backgroundColor: "#43a047",
                            },
                        }}
                    >
                        Contact Us →
                    </Button>
                </Box>
            </section>

            {/* <section style={{ padding: "80px 20px", textAlign: "center" }}>
        <Typography variant="h4" sx={{ mb: 2 }}>
          Careers
        </Typography>
        <Typography variant="body1">[ Add careers info here ]</Typography>
      </section>

      <section style={{ padding: "80px 20px", textAlign: "center" }}>
        <Typography variant="h4" sx={{ mb: 2 }}>
          Contact Us
        </Typography>
        <Typography variant="body1">[ Add contact form here ]</Typography>
      </section> */}
        </div>
    );
};

export default About;
